export default {
  name: "FloorSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};